var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 grey lighten-3"},[_c('router-view',{key:_vm.$route.meta.componentName})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }